module.exports = __webpack_public_path__ + "static/UT_1P_traditional_v2-f720eae0c85eb79b542447a8e6445fdd.png";